export default __webpack_public_path__ + "static/media/sex-male.475d8f26.svg";